export const WorkflowStatus = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REVISION_REQUESTED: 'REVISION_REQUESTED',
};

export const WorkflowAction = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REVISION_REQUESTED: 'REVISION_REQUESTED',
};

export const InvoiceStatus = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  PARTIAL: 'PARTIAL',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  CANCELLED: 'CANCELLED',
};

export const PaymentStatus = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
};

export const PaymentMethod = {
  BANK_TRANSFER: 'BANK_TRANSFER',
  UPI: 'UPI',
  CHEQUE: 'CHEQUE',
  CASH: 'CASH',
  CARD: 'CARD',
};

export const BillingCycle = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ANNUALLY: 'ANNUALLY',
};

export const PayrollStatus = {
  DRAFT: 'DRAFT',
  PROCESSED: 'PROCESSED',
  LOCKED: 'LOCKED',
  PAID: 'PAID',
};

export const AssetStatus = {
  AVAILABLE: 'AVAILABLE',
  ASSIGNED: 'ASSIGNED',
  MAINTENANCE: 'MAINTENANCE',
  RETIRED: 'RETIRED',
};

export const SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
};

export const RecurringType = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
};

export const CustomerType = {
  CORPORATE: 'CORPORATE',
  RETAIL: 'RETAIL',
};

export const PaymentTerms = {
  NET15: 'NET15',
  NET30: 'NET30',
  NET45: 'NET45',
  NET60: 'NET60',
  IMMEDIATE: 'IMMEDIATE',
};

export const DocumentEntityType = {
  EXPENSE: 'EXPENSE',
  REIMBURSEMENT: 'REIMBURSEMENT',
  PROCUREMENT: 'PROCUREMENT',
  PAYROLL: 'PAYROLL',
  ASSET: 'ASSET',
};

export const enumOptions = (obj) =>
  Object.values(obj).map((v) => ({ value: v, label: v.replace(/_/g, ' ') }));
